import { CQ_POTS } from "../../catalogConstants";
import { getPortaActionCharacteristics } from "../normalizers/apiNeeds";
import { commonTypes } from "../common";
import { PRODUCT_TYPES } from "../../utils/catalog";

const types = {
  SET_COMMITMENT_SELECTED: "APISNEEDS/SET_COMMITMENT_SELECTED",
  SET_PORTABILITY_INFO: "APISNEEDS/SET_PORTABILITY_INFO",
  SET_CQ_ID: "APISNEEDS/SET_CQ_ID",
  SET_CHOICES: 'APISNEEDS/SET_CHOICES',
  SAVE_ACTION_INFO_FOR_API: 'APISNEEDS/SAVE_ACTION_INFO_FOR_API',
};

export const initialState = {
  cqId: null,
  getPricesNeeds: {
    portabilityInfo: null,
    chosenActions: [],
  },
  getFeaturesNeeds: {
    chosenActions: null,
    productOfferingsSelected: null,
  },
  productOffering: null,
  productOfferingName: null,
  selectElementsOptions: null,
  selectElementsSecondaryOptions: null,
  selectElementsNeeds: {},
  addToCartNeeds: { chosenActionsArray: null },
  alreadyOwnedProductsChoices: [],
  isMaintainingPromotion: false,
  allChoices: null,
};

const ApisNeedsAscertainReducer = (state, action) => {
  switch (action.type) {
    case types.SET_CQ_ID: {
      const { cqId } = action.payload;
      return {
        ...state,
        cqId,
      };
    }
    case commonTypes.SET_SELECT_ELEMENTS_NEEDS: {
      const {
        mainOptions,
        mainOptionSelected,
        secondaryOptions,
        secondarySelection,
        productOfferingName,
        productOffering,
        cqId,
        productType,
        isMaintainingPromotion,
        secondaryOptionsForUI,
      } = action.payload;

      let selectElementsNeeds = null;
      let newAllChoices = JSON.parse(JSON.stringify(state.allChoices));

      if (mainOptionSelected) {
        const optionSelectedObj = mainOptions.find(
          (mainOpt) => mainOpt.actionId === mainOptionSelected
        );

        if (optionSelectedObj) {
          selectElementsNeeds = {
            actionId: optionSelectedObj.actionId,
            cqsiId: optionSelectedObj.cqsiId,
            productType: optionSelectedObj.productType,
            selectedByClient: false,
          };

          if (optionSelectedObj.clientPhoneNumberToBeAppliedTo) {
            selectElementsNeeds.clientPhoneNumberToBeAppliedTo =
              optionSelectedObj.clientPhoneNumberToBeAppliedTo;
          }

          if (secondarySelection) {
            selectElementsNeeds.secondarySelection = secondarySelection;
          }

          const newMainItem = {
            actionId: optionSelectedObj.actionId,
            phoneNumber: optionSelectedObj.clientPhoneNumberToBeAppliedTo,
            description: optionSelectedObj.description,
            productOfferingName: optionSelectedObj.productOfferingName,
          };

          if (
            secondaryOptionsForUI &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE] &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][
              mainOptionSelected
            ] &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
              .choiceGroups &&
            Array.isArray(
              secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
                .choiceGroups
            ) &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
              .choiceGroups.length === 1
          ) {
            const landLineChoice =
              secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
                .choiceGroups[0];
            if (
              landLineChoice &&
              landLineChoice.customerQuoteItems &&
              Array.isArray(landLineChoice.customerQuoteItems) &&
              landLineChoice.customerQuoteItems.length === 1 &&
              landLineChoice.customerQuoteItems[0].phoneOptions &&
              landLineChoice.customerQuoteItems[0].phoneOptions.length === 1
            ) {
              const customerQuoteItem = landLineChoice.customerQuoteItems[0];
              let landLinePhoneNumber;
              if (
                customerQuoteItem.phoneOptions &&
                Array.isArray(customerQuoteItem.phoneOptions) &&
                customerQuoteItem.phoneOptions.length === 1 &&
                customerQuoteItem.phoneOptions[0].value
              ) {
                landLinePhoneNumber = customerQuoteItem.phoneOptions[0].value;
              }
              const newItem = {
                actionId: customerQuoteItem.actionId,
                phoneNumber: landLinePhoneNumber,
                productOfferingName: customerQuoteItem.productOfferingName,
                description: customerQuoteItem.description,
              };
              if (newMainItem.secondaryChoices) {
                if (newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE]) {
                  newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE] = [
                    ...newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE],
                    newItem,
                  ];
                } else {
                  newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE] = [
                    newItem,
                  ];
                }
              } else {
                newMainItem.secondaryChoices = {
                  [PRODUCT_TYPES.LAND_LINE]: [newItem],
                };
              }
            }
          }

          if (
            secondaryOptionsForUI &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE] &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][
              mainOptionSelected
            ] &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
              .keepGroups &&
            Array.isArray(
              secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
                .keepGroups
            ) &&
            secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
              .keepGroups.length === 1
          ) {
            const landLineChoice =
              secondaryOptionsForUI[PRODUCT_TYPES.LAND_LINE][mainOptionSelected]
                .keepGroups[0];
            if (
              landLineChoice &&
              landLineChoice.customerQuoteItems &&
              Array.isArray(landLineChoice.customerQuoteItems) &&
              landLineChoice.customerQuoteItems.length === 1 &&
              landLineChoice.customerQuoteItems[0].phoneOptions &&
              landLineChoice.customerQuoteItems[0].phoneOptions.length === 1
            ) {
              const customerQuoteItem = landLineChoice.customerQuoteItems[0];
              let landLinePhoneNumber;
              if (
                customerQuoteItem.phoneOptions &&
                Array.isArray(customerQuoteItem.phoneOptions) &&
                customerQuoteItem.phoneOptions.length === 1 &&
                customerQuoteItem.phoneOptions[0].value
              ) {
                landLinePhoneNumber = customerQuoteItem.phoneOptions[0].value;
              }
              const newItem = {
                actionId: customerQuoteItem.actionId,
                phoneNumber: landLinePhoneNumber,
                productOfferingName: customerQuoteItem.productOfferingName,
                description: customerQuoteItem.description,
              };
              if (newMainItem.secondaryChoices) {
                if (newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE]) {
                  newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE] = [
                    ...newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE],
                    newItem,
                  ];
                } else {
                  newMainItem.secondaryChoices[PRODUCT_TYPES.LAND_LINE] = [
                    newItem,
                  ];
                }
              } else {
                newMainItem.secondaryChoices = {
                  [PRODUCT_TYPES.LAND_LINE]: [newItem],
                };
              }
            }
          }

          if (
            secondaryOptionsForUI &&
            secondaryOptionsForUI[PRODUCT_TYPES.MOBILE] &&
            secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected] &&
            secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
              .keepGroups &&
            Array.isArray(
              secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
                .keepGroups
            ) &&
            secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
              .keepGroups.length > 0
          ) {
            const keepChoices =
              secondaryOptionsForUI[PRODUCT_TYPES.MOBILE][mainOptionSelected]
                .keepGroups;
            keepChoices.forEach((choice) => {
              if (
                choice &&
                choice.customerQuoteItems &&
                Array.isArray(choice.customerQuoteItems) &&
                choice.customerQuoteItems.length === 1 &&
                choice.customerQuoteItems[0].phoneOptions &&
                choice.customerQuoteItems[0].phoneOptions.length === 1
              ) {
                choice.customerQuoteItems.forEach((item) => {
                  const newItem = {
                    actionId: item.actionId,
                    productOfferingName: item.productOfferingName,
                    description: item.description,
                    phoneNumber: item.phoneOptions[0].value,
                  };
                  if (newMainItem.secondaryChoices) {
                    if (
                      newMainItem.secondaryChoices &&
                      newMainItem.secondaryChoices[PRODUCT_TYPES.MOBILE]
                    ) {
                      newMainItem.secondaryChoices[PRODUCT_TYPES.MOBILE] = [
                        ...newMainItem.secondaryChoices[PRODUCT_TYPES.MOBILE],
                        newItem,
                      ];
                    } else {
                      newMainItem.secondaryChoices[PRODUCT_TYPES.MOBILE] = [
                        newItem,
                      ];
                    }
                  } else {
                    newMainItem.secondaryChoices = {
                      [PRODUCT_TYPES.MOBILE]: [newItem],
                    };
                  }
                });
              }
            });
          }
          if (newAllChoices) {
            if (newAllChoices[optionSelectedObj.productType]) {
              newAllChoices[optionSelectedObj.productType] = [
                ...newAllChoices[optionSelectedObj.productType],
                newMainItem,
              ];
            } else {
              newAllChoices[optionSelectedObj.productType] = [newMainItem];
            }
          } else {
            newAllChoices = {
              [optionSelectedObj.productType]: [newMainItem],
            };
          }
        }
      }

      const newState = {
        ...state,
        cqId,
        productType,
        productOfferingName,
        productOffering,
        selectElementsNeeds,
        selectElementsOptions: mainOptions,
        selectElementsSecondaryOptions: secondaryOptions,
        isMaintainingPromotion: state.isMaintainingPromotion || isMaintainingPromotion,
        allChoices: newAllChoices,
      };

      return {
        ...newState,
      };
    }
    case types.SET_CHOICES: {
      const { choices } = action.payload;
      if(!choices){
        return {
          ...state,
        }
      }
      if (!state.allChoices) {
        return {
          ...state,
          allChoices: choices,
        };
      }
      const newAllChoices = JSON.parse(JSON.stringify(state.allChoices));
      Object.keys(choices).forEach((key) => {
        if (newAllChoices[key]) {
          if (
            newAllChoices[key].length === 1 &&
            choices[key].length === 1 &&
            newAllChoices[key][0].actionId === choices[key][0].actionId &&
            (newAllChoices[key][0].secondaryChoices ||
              choices[key][0].secondaryChoices) // TODO Mejor hacer que llegue po y asegurar que es mismo item?
          ) {
            if (newAllChoices[key][0].secondaryChoices) {
              Object.keys(choices[key][0].secondaryChoices).forEach((secondaryChoiceKey) => {
                if(newAllChoices[key][0].secondaryChoices[secondaryChoiceKey]){
                  newAllChoices[key][0].secondaryChoices[secondaryChoiceKey] = [
                    ...newAllChoices[key][0].secondaryChoices[secondaryChoiceKey],
                    ...choices[key][0].secondaryChoices[secondaryChoiceKey],
                  ];
                } else {
                  newAllChoices[key][0].secondaryChoices[secondaryChoiceKey] = choices[key][0].secondaryChoices[secondaryChoiceKey];
                }
              });
            } else if (choices[key][0].secondaryChoices) {
              newAllChoices[key][0].secondaryChoices = {
                ...choices[key][0].secondaryChoices,
              };
            }
          } else {
            newAllChoices[key] = [...newAllChoices[key], ...choices[key]];
          }
        } else {
          newAllChoices[key] = choices[key];
        }
      });
      return {
        ...state,
        allChoices: newAllChoices,
      };
    }
    case types.SAVE_ACTION_INFO_FOR_API: {
      const { newSelectElementsNeeds } = action.payload;
      return {
        ...state,
        selectElementsNeeds: newSelectElementsNeeds,
      };
    }
    case commonTypes.SET_ADD_TO_CART_NEEDS: {
      const { actionsResolved, response } = action.payload;
      const { components } = response;
      const { portabilityInfo } = state.getPricesNeeds;

      const chosenActions = getPortaActionCharacteristics(
        components,
        portabilityInfo
      ); // TODO MULTIPLAZO refactor para resolver todas juntas??

      return {
        ...state,
        addToCartNeeds: {
          chosenActionsArray: actionsResolved ? actionsResolved : null,
        },
        getPricesNeeds: {
          ...state.getPricesNeeds,
          chosenActions: [
            ...state.getPricesNeeds.chosenActions,
            ...chosenActions,
          ],
        },
      };
    }
    case types.SET_COMMITMENT_SELECTED: {
      const { commitmentSelected } = action.payload;
      const { chosenActionsArray } = state.addToCartNeeds;

      if (
        commitmentSelected &&
        chosenActionsArray &&
        Array.isArray(chosenActionsArray) &&
        chosenActionsArray.length === 1
      ) {
        return {
          ...state,
          addToCartNeeds: {
            chosenActionsArray: [
              {
                ...state.addToCartNeeds.chosenActionsArray[0],
                offeringTerms: [
                  {
                    id: commitmentSelected,
                    type: CQ_POTS.COMMITMENT_POT.TYPE,
                  },
                ],
              },
            ],
          },
        };
      }
      return { ...state };
    }
    case commonTypes.SET_ALREADY_OWNED_PRODUCTS_CHOICES: {
      const { alreadyOwnedProductsChoicesObj } = action.payload;

      if (
        alreadyOwnedProductsChoicesObj &&
        alreadyOwnedProductsChoicesObj.alreadyOwnedProductsChoices &&
        Array.isArray(
          alreadyOwnedProductsChoicesObj.alreadyOwnedProductsChoices
        ) &&
        Array.isArray(
          alreadyOwnedProductsChoicesObj.autoSelectedAlreadyOwnedProductsChoices
        )
      ) {
        const {
          alreadyOwnedProductsChoices,
          autoSelectedAlreadyOwnedProductsChoices,
        } = alreadyOwnedProductsChoicesObj;
        return {
          ...state,
          alreadyOwnedProductsChoices,
          getFeaturesNeeds: {
            chosenActions: autoSelectedAlreadyOwnedProductsChoices,
          },
        };
      }

      return null;
    }
    case commonTypes.SET_ALREADY_OWNED_PRODUCT_CHOICE_SELECTED: {
      const { groupId, id, poId } = action.payload;

      let newChosenActions = [];
      let newProductOfferingsSelected = [];

      if (state.getFeaturesNeeds.chosenActions) {
        newChosenActions = JSON.parse(
          JSON.stringify(state.getFeaturesNeeds.chosenActions)
        );
      }

      if (state.getFeaturesNeeds.productOfferingsSelected) {
        newProductOfferingsSelected = JSON.parse(
          JSON.stringify(state.getFeaturesNeeds.productOfferingsSelected)
        );
      }

      const newChosenAction = {
        id: groupId,
        customerQuoteItems: [
          {
            id,
          },
        ],
      };

      const alreadySelectedChosenAction = newChosenActions.find(
        (chosenAction) => chosenAction.id === groupId
      );

      if (alreadySelectedChosenAction) {
        const alreadySelectedChosenActionIndex = newChosenActions.indexOf(
          alreadySelectedChosenAction
        );
        newChosenActions[alreadySelectedChosenActionIndex] = newChosenAction;
        newProductOfferingsSelected[alreadySelectedChosenActionIndex] = poId;
      } else {
        newChosenActions.push(newChosenAction);
        newProductOfferingsSelected.push(poId);
      }

      return {
        ...state,
        getFeaturesNeeds: {
          chosenActions: newChosenActions,
          productOfferingsSelected: newProductOfferingsSelected,
        },
      };
    }
    case types.SET_PORTABILITY_INFO: {
      const { portabilityInfo } = action.payload;

      if (portabilityInfo) {
        return {
          ...state,
          getPricesNeeds: {
            ...state.getPricesNeeds,
            portabilityInfo,
          },
        };
      }
      return { ...state };
    }
    case commonTypes.SET_PORTABILITY_OTP_NEEDED: {
      const { otpNeeded } = action.payload;
            
      return {
        ...state,
        portabilityOTPNeeded: otpNeeded,
      };
      
    }
    default:
      return null;
  }
};

export const actions = {
  setCqId: (cqId) => ({
    type: types.SET_CQ_ID,
    payload: {
      cqId,
    },
  }),
  setCommitmentSelected: (commitmentSelected) => ({
    type: types.SET_COMMITMENT_SELECTED,
    payload: {
      commitmentSelected,
    },
  }),
  setPortabilityInfo: (portabilityInfo) => ({
    type: types.SET_PORTABILITY_INFO,
    payload: {
      portabilityInfo,
    },
  }),
  setChoices: choices => ({
    type: types.SET_CHOICES,
    payload: {
      choices,
    },
  }),
  saveActionInfoForApi: newSelectElementsNeeds => ({
    type: types.SAVE_ACTION_INFO_FOR_API,
    payload: {
      newSelectElementsNeeds,
    }
  }),
};

export default ApisNeedsAscertainReducer;
